import { useQuery } from "@tanstack/react-query";
import type { Role } from "@mandrac/shared";
import { api, ApiError } from "./api";

export interface Me {
  user: { id: string; email: string; name: string; locale: "hr" | "en" };
  authority: { id: string; name: string; slug: string } | null;
  authorities: Array<{ id: string; name: string; slug: string }>;
  roles: Role[];
  ports: Array<{ id: string; name: string; slug: string }>;
  isPlatformAdmin: boolean;
  impersonating: boolean;
  deviceId: string | null;
  csrfToken: string;
}

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        return await api<Me>("/auth/me");
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 60_000,
    retry: (count, e) => !(e instanceof ApiError && e.status < 500) && count < 2,
  });
}

export function hasAnyRole(me: Me | null | undefined, ...roles: Role[]) {
  return !!me && me.roles.some((r) => roles.includes(r));
}

export interface AppConfig {
  environment: string;
  publicBaseUrl: string;
  appBaseUrl: string;
  mapTileUrl: string;
  mapAttribution: string;
}

export function useConfig() {
  return useQuery({ queryKey: ["config"], queryFn: () => api<AppConfig>("/config"), staleTime: Infinity });
}
